<div
  #rootElement
  class="studio-measure-input"
  [class.is-open]="showPresetMenu || showUnitMenu"
  [class.is-keyword]="currentMode === 'keyword'"
  (focusout)="handleFocusOut($event)"
>
  <div class="studio-measure-input__group">
    @if (currentMode !== 'keyword') {
      <div class="studio-measure-input__field-anchor">
        <div class="studio-measure-input__field-shell">
          <input
            #valueInput
            class="studio-measure-input__field"
            type="text"
            [value]="displayInputValue"
            [placeholder]="inputPlaceholder"
            [readOnly]="inputReadOnly"
            [class.is-readonly]="inputReadOnly"
            (input)="handleInput(valueInput.value)"
            (click)="openPresetMenu()"
          />

          <div class="studio-measure-input__stepper">
            <button
              type="button"
              class="studio-measure-input__stepper-button studio-measure-input__stepper-button--up"
              aria-label="Increase value"
              [disabled]="stepperDisabled"
              (click)="nudgeValue(1)"
            ></button>
            <button
              type="button"
              class="studio-measure-input__stepper-button studio-measure-input__stepper-button--down"
              aria-label="Decrease value"
              [disabled]="stepperDisabled"
              (click)="nudgeValue(-1)"
            ></button>
          </div>
        </div>
      </div>
    }

    <div class="studio-measure-input__unit-shell">
      <button
        #unitButton
        type="button"
        class="studio-measure-input__unit-button"
        [class.is-open]="showUnitMenu"
        aria-haspopup="listbox"
        [attr.aria-expanded]="showUnitMenu"
        (click)="toggleUnitMenu()"
      >
        <span>{{ selectedUnitLabel }}</span>
        <span class="studio-measure-input__unit-caret" aria-hidden="true"></span>
      </button>
    </div>
  </div>

  @if (showPresetMenu && presetSections.length) {
    <div
      #presetMenu
      class="studio-measure-input__menu studio-measure-input__menu--presets bw-dropdown-scroll"
      role="listbox"
      aria-label="Suggested values"
    >
      @for (section of presetSections; track section.id) {
        <div class="studio-measure-input__menu-section">
          @if (showPresetSectionHeadings) {
            <p class="studio-measure-input__menu-heading">{{ section.label }}</p>
          }
          <div class="studio-measure-input__menu-list">
            @for (preset of section.values; track preset) {
              <button
                type="button"
                class="studio-measure-input__menu-option"
                [class.is-active]="isPresetActive(preset)"
                (click)="selectPreset(preset)"
              >
                {{ preset }}
              </button>
            }
          </div>
        </div>
      }
    </div>
  }

  @if (showUnitMenu) {
    <div
      #unitMenu
      class="studio-measure-input__menu studio-measure-input__menu--units bw-dropdown-scroll"
      role="listbox"
      aria-label="Value type"
    >
      @for (section of typeSections; track section.id) {
        <div class="studio-measure-input__menu-section">
          @if (showTypeSectionHeadings) {
            <p class="studio-measure-input__menu-heading">{{ section.label }}</p>
          }
          <div class="studio-measure-input__menu-list">
            @for (option of section.options; track option.kind + ':' + option.value) {
              <button
                type="button"
                class="studio-measure-input__menu-option"
                [class.is-active]="isTypeOptionActive(option)"
                (click)="selectTypeOption(option)"
              >
                {{ option.label }}
              </button>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
